module.exports = "<component v-if=isInterrupt slot=content is=type_interrupt :content=fragments[0].content></component><component v-else=v-else slot=content :is=layout :content=fragments[0] :uid=uid></component>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/fragments/set.vue
// module id = 431
// module chunks = 0